/**
 *
 * Asynchronously loads the component for ClassSummary
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const ClassSummary = lazyLoad(
  () => import('./index'),
  module => module.ClassSummary,
);
